import * as fns from 'date-fns'
import { CommonLanguageBridge } from './common-language-bridge.js'

export class CommonDateBridge {
	constructor(private Language: typeof CommonLanguageBridge) {}

	readonly fns = fns

	format(date: Date | number, format: string) {
		if (typeof date === 'number') date = new Date(date)
		if (!date) return ''
		return fns.format(date, format, {
			locale: this.Language.dateLocale,
		})
	}
}
